<template>
  <div id="body_HTG"  v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][htgBetType]">
    <!------------------------ HTG ------------------------>
    <table id="model_HTG" border="0" cellpadding="0" cellspacing="0" class="more_table2">
      <tbody>
        <!--tr style="height:2px"><td class="emptyrow"  :class="{isrb: newAllBetEvent.event_rb==1}"  colspan="2"></td></tr-->
        <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][htgBetType]).length)">
          <template v-if="newAllBetEvent.od[plytyp][htgBetType][Object.keys(newAllBetEvent.od[plytyp][htgBetType])[subMatchKey]]">
            <template v-if="newAllBetEvent.od[plytyp][htgBetType][Object.keys(newAllBetEvent.od[plytyp][htgBetType])[subMatchKey]]['hdp'] != 0">
              <tr v-if="subMatchKey == 0">
                <th class="more_title4" colspan="2"  @click="showLeg()">
                  <button id="triggertoggle" class="trigger toggle-primary" :class="show ? 'icon-open' : 'icon-close'"></button>

                  <span class="btheader">{{ oddsHeader() }}{{ sportAllBetLang['ALL_BET.HTG'] }}</span>

                  <template v-if="plytyp == firstHtPlyType">
                    <span class="more_og2">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_1HT'] }}</span>
                  </template>
                </th>
              </tr>
              <template v-if="show">
                <template v-if="subMatchKey == 0">
                  <tr>
                    <th class="allbetheader header" width="50%">  
                      <div class="more_font" :title="sportAllBetLang['ALL_BET.LBL_OVER']">
                        <span class=""> {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} ({{ newAllBetEvent.od[plytyp][htgBetType][Object.keys(newAllBetEvent.od[plytyp][htgBetType])[subMatchKey]]['hdp'] }})</span>
                      </div>
                    </th>
                    <th class="allbetheader header" width="50%">  
                      <div class="more_font" :title="sportAllBetLang['ALL_BET.LBL_UNDER']">
                        <span class=""> {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} ({{ newAllBetEvent.od[plytyp][htgBetType][Object.keys(newAllBetEvent.od[plytyp][htgBetType])[subMatchKey]]['hdp'] }})</span>
                      </div>
                    </th>
                  </tr>
                </template>
                <tr :class="{more_white: subMatchKey % 2 == 0, more_color: subMatchKey % 2 != 0}">
                  <td class="cursorcontent allbetcontent abcs" :class="{isrb: newAllBetEvent.event_rb==1}"  style="cursor:pointer" width="50%" @click="selectCell($event,'teamOver'+subMatchKey)">
                    <div class="betArea" style="margin:auto;width:200px">
                      <span class="" :title="sportAllBetLang['ALL_BET.LBL_OVER']">
                        <odd :event="newAllBetEvent" :team="teamA" :plyType="plytyp" :betType="htgBetType" :match="subMatchKey" :ref="'teamOver'+subMatchKey"/>
                      </span>
                    </div>
                  </td>
                  <td class="cursorcontent allbetcontent abcs" :class="{isrb: newAllBetEvent.event_rb==1}"  style="cursor:pointer" width="50%" @click="selectCell($event,'teamUnder'+subMatchKey)">
                    <div class="betArea" style="margin:auto;width:200px">
                      <span class="" :title="sportAllBetLang['ALL_BET.LBL_UNDER']">
                        <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="htgBetType" :match="subMatchKey" :ref="'teamUnder'+subMatchKey"/>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

  import OddComponents from '../../../components/odd'
  import OverUnderComponents from '../../../components/over-under'

  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent : null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            btypes: [allBetMixin.data().htgBetType, allBetMixin.data().rhtgBetType],
            show: true,
        }
    },
    computed: {
      newAllBetEvent () {
        return this.allBetEvent
      }
    },
    methods: {
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      addToMyMarket(plytyp,htgBetType) {
        if(this.selectMarket)
          this.selectMarket(this.newAllBetEvent, plytyp, htgBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp,htgBetType) {
        if(this.removeMarket)
          this.removeMarket(this.newAllBetEvent, plytyp, htgBetType, this.isSpecial)
      },
      oddsHeader() {
        var retCapt = ''
        
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.htgBetType)
        
        return retCapt
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-htg.vue